/**
 * ÖNEMLİ: Bu katman bir güvenlik sınırı değildir. Taşıma zaten TLS ile şifrelidir.
 * Amaç, DevTools'tan payload kopyalayıp oynayan saldırganı zorlaştıran bir
 * obfuscation katmanıdır. Gerçek koruma sunucu tarafındaki kimlik ve sahiplik
 * doğrulamasıdır. Sunucu hem binary hem JSON payload kabul eder.
 *
 * Geliştirici JSON modu: localStorage.setItem("supsisSocketJson", "1") veya
 * sayfa adresinde ?supsis-debug=1 varsa payload düz JSON olarak gönderilir.
 */
const FORMAT_VERSION = 0x01;
const NONCE_LENGTH = 4;
/**
 * Giden tüm event'ler tek bir opak event adı altında tünellenir; böylece
 * socket.io çerçevesinde gerçek event adı da görünmez.
 */
export const TUNNEL_EVENT = "s";
const DEFAULT_KEY = "supsis-visitor-payload-v1";
const KEY = process.env.VISITOR_PAYLOAD_KEY || DEFAULT_KEY;
const JSON_MODE_KEY = "supsisSocketJson";

const keyBytes = (() => {
    const bytes = [];
    for (let i = 0; i < KEY.length; i++) bytes.push(KEY.charCodeAt(i) & 0xff);
    return bytes;
})();

const keystreamByte = (index, nonce) => {
    return (keyBytes[index % keyBytes.length] ^ nonce[index % NONCE_LENGTH] ^ ((index * 31) & 0xff)) & 0xff;
};

/**
 * Geliştirici JSON modunun açık olup olmadığını döner.
 * @returns {boolean}
 */
export const isJsonDebugModeEnabled = () => {
    try {
        if (localStorage.getItem(JSON_MODE_KEY) === "1") return true;
        return (window.location.search || "").indexOf("supsis-debug=1") !== -1;
    } catch (e) {
        return false;
    }
};

const randomNonce = () => {
    const nonce = new Uint8Array(NONCE_LENGTH);
    if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(nonce);
    } else {
        for (let i = 0; i < NONCE_LENGTH; i++) nonce[i] = Math.floor(Math.random() * 256);
    }
    return nonce;
};

/**
 * JSON payload'ı binary formata çevirir.
 * @param {object} payload
 * @returns {Uint8Array}
 */
export const encodeVisitorPayload = (payload) => {
    const json = JSON.stringify(payload === undefined ? null : payload);
    const bodyBytes = new TextEncoder().encode(json);
    const nonce = randomNonce();
    const result = new Uint8Array(1 + NONCE_LENGTH + bodyBytes.length);
    result[0] = FORMAT_VERSION;
    result.set(nonce, 1);
    for (let i = 0; i < bodyBytes.length; i++) {
        result[1 + NONCE_LENGTH + i] = bodyBytes[i] ^ keystreamByte(i, nonce);
    }
    return result;
};



// WEBPACK FOOTER //
// ./src/utils/visitorPayloadCodec.js